<template>
  <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
    <div style="font-size: 30px; font-weight: 700; margin-right: 20px; width: 64px; height: 56px; background-color: #154079; color: #fff; display: flex; justify-content: center; align-items: center;">{{ index }}</div>
    <div style="font-size: 30px; font-weight: 700; position: relative; padding-bottom: 8px; height: 56px; display: flex; align-items: center;">{{ label }}
      <span style="content: ''; position: absolute; bottom: 0; left: 0; width: 320px; height: 2px; background-color: #FF9F43;"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionComponent',
  props: {
    index: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.section-component {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.section-index {
  font-size: 30px;
  font-weight: 700;
  margin-right: 20px;
  width: 64px;
  height: 56px;
  background-color: #154079;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-label {
  font-size: 30px;
  font-weight: 700;
  position: relative;
  padding-bottom: 8px;
  height: 56px;
  display: flex;
  align-items: center;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 320px;
    height: 2px;
    background-color: #FF9F43;
  }
}
</style> 